import { Injectable } from '@angular/core';
import {
    Router,
    CanActivate,
    ActivatedRouteSnapshot,
    RouterStateSnapshot
} from '@angular/router';
import { tokenNotExpired } from 'angular2-jwt';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

        // Redirect to external Compass application
       if (state.url === '/compass') {
            window.open('https://compass.creatingwow.in/', '_blank');
            this.router.navigate(['/home']); // or any default page
            return false;
        }


        console.log(tokenNotExpired());

        if (tokenNotExpired()) {
            return true;
        }

        window.localStorage.removeItem('pagedetails');
        window.localStorage.removeItem('currentUser');
        window.localStorage.removeItem('id_token');
        window.localStorage.removeItem('img');

        this.router.navigate(['/login']);
        return false;
    }
}


// WEBPACK FOOTER //
// ./src/app/Shared/AuthGuards/auth.guard.ts